export default "__VITE_PUBLIC_ASSET__f7f063bc__"